<template>
    <b-modal
        id="add-existing-magazine-editor-user"
        modal-class="apprentice-default-modal"
        ok-only
        :ok-title="$t('common.close')"
        ok-variant="primary"
        size="md"
        :title="$t('magazine.add_existing_user')"
        @show="getUsers()">
        <div class="add-existing-editor">
            <design-2021-apprentice-data-table
                :fields="fields"
                :items="users">
                <template v-slot:cell(actions)="data">
                    <div class="actions">
                        <b-button
                            class="btn-hand-pointer btn-select-user"
                            v-b-tooltip.hover
                            :title="$t('common.choose')"
                            variant="primary-icon-only"
                            @click="onSelect(data.item.id)">
                        </b-button>
                    </div>
                </template>
            </design-2021-apprentice-data-table>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-magazine-editor-add-existing-user-component',
    props: {
        magazineId: {
            type: Number,
        },
    },
    data() {
        const magazineId = this.magazineId;
        return {
            fields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            users: [],
        };
    },
    methods: {
        getUsers() {
            this.axios.get(this.routes.magazineUsersAll(this.magazineId)).then(
                (response) => {
                    this.users = response.data;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        onSelect(id) {
            this.axios.post(this.routes.magazineUserAdd(this.magazineId), { user_id: id }).then(
                (response) => {
                    this.$emit('update-users', response.data.user);
                    this.alert.success(
                        this.$t('magazine.user_added'),
                        this.$t('magazine.the_user_has_been_added_to_the_editorial_team'),
                    );
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
